import { enableProfiling } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { FourdModule } from './app/fourd.module';
//import { environment } from './environments/environment';

//if (environment.production) {
//  enableProdMode();
//}

enableProfiling();
platformBrowser().bootstrapModule(FourdModule);
